import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M8.551 12.625a.5.5 0 0 1 .897 0l2.031 4.116a.5.5 0 0 0 .377.273l4.541.66a.5.5 0 0 1 .277.853l-3.286 3.203a.5.5 0 0 0-.144.443l.776 4.523a.5.5 0 0 1-.726.527l-4.062-2.135a.5.5 0 0 0-.465 0l-4.062 2.135a.5.5 0 0 1-.726-.527l.776-4.523a.5.5 0 0 0-.144-.442l-3.286-3.204a.5.5 0 0 1 .277-.853l4.542-.66a.5.5 0 0 0 .376-.273z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.35",
      d: "M1.665 5.87a.5.5 0 0 1 .235-.423l6.956-4.348a.5.5 0 0 1 .53 0l6.957 4.348a.5.5 0 0 1 .235.424v3.48a.5.5 0 0 1-.765.425L9.386 5.759a.5.5 0 0 0-.53 0L2.43 9.776a.5.5 0 0 1-.765-.424z"
    }, null, -1)
  ]))]))
}
export default { render: render }